module.exports = __webpack_public_path__ + "static/irishOpenStringPadEnding-b7dfc7bd09f2793a7b3ec0a4a08dee92.mp3";